import AlertBanner from "components/Banner/AlertBanner";
import type React from "react";

const LoginErrorBanner = (props: {
  authError?: unknown;
}): React.ReactElement => {
  const err = props.authError as
    | { code?: string; message?: string }
    | null
    | undefined;
  return (
    <>
      {err &&
        (["NotAuthorizedException", "UserNotFoundException"].includes(
          err.code ?? "",
        ) ? (
          <AlertBanner className={"mt-3 bg-red-700"}>
            <p className={"text-lg font-weight-bold"}>Login failed</p>
            <p> Your email address or password are not valid.</p>
            <p>Please try again.</p>
          </AlertBanner>
        ) : (
          <AlertBanner className={"mt-3 bg-red-700"}>
            <p className={"text-lg font-weight-bold"}>Login failed</p>
            <p>{err.message}</p>
            <p>Please try again.</p>
          </AlertBanner>
        ))}
    </>
  );
};

export default LoginErrorBanner;
